<p-dialog #visorDialog *ngIf="!inline; else inlineTemplate" (onHide)="closeDialog()" [(visible)]="show"
    [maximizable]="true" [modal]="true" [resizable]="true"
    [style]="{maxWidth: '100%', width: '900px', height: (height)?height:'800px'}">
    <ng-template pTemplate="header">
        <h5 class="p-dialog-header-title">{{title}}</h5>
    </ng-template>
    <ng-content select="#content"> </ng-content>
    <iframe [title]="title" *ngIf="!!url && !isMobile" [src]="url" height="93%" width="100%"></iframe>
    <div class="flex justify-content-around mb-3">
        <button *ngIf="isButton1Visible" pButton type="button" [label]="button1Label" (click)="onButton1Click()"
            class="tax-app-button" style="width: 10rem;"></button>
        <button *ngIf="isButton2Visible" pButton type="button" [label]="button2Label" class="tax-app-button"
            (click)="onButton2Click()" style="width: 10rem;"></button>
    </div>
</p-dialog>
<ng-template #inlineTemplate>
    <iframe [title]="title" [src]="url" height="100%" width="100%" style="height: 100vh;"></iframe>
</ng-template>